import * as UsersAPI from 'remote/users'
import { dataFetched } from 'data/graphql'
export const updateUserPreferences = params => ({
  dispatch,
  graphQLClient,
}) => {
  return {
    type: 'UDPATE_USER_PREFERENCES',
    payload: {
      promise: graphQLClient
        .mutate({
          query: UsersAPI.updateUserPreferences,
          variables: {
            ...params,
          },
        })
        .then(({ data }) => {
          dispatch(dataFetched(data.updateUserPreferences))
        }),
    },
  }
}
